import { render, staticRenderFns } from "./MerchantSettlements.vue?vue&type=template&id=689ceecc"
import script from "./MerchantSettlements.vue?vue&type=script&lang=js"
export * from "./MerchantSettlements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports